
/**
 * @enum {string}
 */
export default {
  LAYER_DEFINITION_CHANGED: 'layer_definition_changed',
  VISIBLE_CHANGED: 'visible_changed',
  GRID_VISIBLE_CHANGED: 'grid_visible_changed',
  ACTIVE_CHANGED: 'active_changed',
  SEARCH_TEXT_CHANGED: 'search_text_changed',
  THEME_CHANGED: 'theme_changed',
  FILTERED_COLUMNS_CHANGED: 'filtered_columns_changed',
  DISPOSE_REQUESTED: 'dispose_requested',

  SELECTION_CHANGED: 'selection_changed',
  UPDATE_REQUESTED: 'update_requested',
  ZOOM_ITEM_CHANGED: 'zoom_item_changed',
};

